import { connect } from 'react-redux';

import PlatformFirstLanding, { ILandingDispatchProps, ILandingStoreProps } from './platform-first-landing.component';
import { goToLoginPage } from '../login/login.actions';
import { broadcastHasSession } from 'modules/login/login.actions';

/* eslint-disable-next-line*/
const mapStateToProps = (state: any): ILandingStoreProps => ({
    fetching: state.login.fetching,
    loginSession: state.login.loginSession
});

const mapDispatchToProps: ILandingDispatchProps = {
    goToLoginPage,
    broadcastHasSession
};

const PlatformFirstLandingContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlatformFirstLanding);

export default PlatformFirstLandingContainer;
